import { Button, MessageSquare } from "@app/ui";
import { useI18n } from "../../lib/useI18n.js";
import { useFeedbackStore } from "./feedback.store.js";

export function FeedbackButton({ mini = false }: { mini?: boolean }) {
  const { t } = useI18n();
  function openFeedback() {
    useFeedbackStore.getState().openFeedback({ source: "sidebar" });
  }

  if (mini) {
    return (
      <Button type="button" variant="ghost" size="icon" title={t("common.feedback")} aria-label={t("common.feedback")} onClick={openFeedback}>
        <MessageSquare size={22} />
      </Button>
    );
  }

  return (
    <Button type="button" variant="ghost" className="justify-start px-3" onClick={openFeedback}>
      <MessageSquare className="h-4 w-4" /> {t("common.feedback")}
    </Button>
  );
}
